export default "__VITE_ASSET__EwEkV9IX__"